import ProjectSummaryPage from "@/pages/ProjectSummaryPage";

export default function DashboardPage() {
  return <ProjectSummaryPage dashboardMode />;
}
